import { useCallback, useState } from 'react';
import debounce from 'lodash.debounce';
import { useDispatch } from 'react-redux';

export default function useDebouncedSearch(globalSearch, setGlobalSearch) {
  const dispatch = useDispatch();
  const [localSearchValue, setLocalSearchValue] = useState(globalSearch);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce(value => {
      dispatch(setGlobalSearch(value));
    }, 300),
    []
  );

  const handleSearch = useCallback(
    (value, clearClick) => {
      setLocalSearchValue(value);
      if (clearClick) {
        dispatch(setGlobalSearch(''));
      } else {
        debouncedSearch(value);
      }
    },
    [debouncedSearch, dispatch, setGlobalSearch]
  );

  const resetLocalSearchValue = useCallback(
    () => setLocalSearchValue(globalSearch),
    [globalSearch]
  );
  return [localSearchValue, handleSearch, resetLocalSearchValue];
}
